import HostFreeAreaService from '@/services/free-area/host-free-area'

export default class InquiryFreeAreaService extends HostFreeAreaService {
  protected get freeAreaPaths() {
    return [
      'InquiryHeader',
    ]
  }
}
